import React, {useState} from "react";
import {DateInput} from "@/component/input/DateInput";
import {AmountInput} from "@/component/input/AmountInput";
import {FtDialog} from "@/common/FtDialog";
import {useAccountStore} from "@/store/useAccountStore";
import {InputWrap} from "@/component/input/InputWrap";
import {StringInput} from "@/component/input/StringInput";
import {FtButton} from "@/common/FtButton";
import {useCreateTransLimit} from "@/hook/useTransLimits";

interface Props {
    accountId: number;
    applyDate: string;
    handleClose: () => void;
}

interface FormData {
    accountId: number;
    applyDate: string;
    amount: number;
    detail: string;
}

export function AddTransLimitDialog(props: Props) {
    const accountName = useAccountStore(state => state.getAccountNameById(props.accountId));
    const createTransLimit = useCreateTransLimit();

    const [data, setData] = useState<FormData>({
        accountId: props.accountId,
        applyDate: props.applyDate,
        amount: 0,
        detail: "",
    });

    async function handleSubmit() {
        await createTransLimit.mutateAsync(data);
        props.handleClose();
    }

    if (!open) return null;

    return (
        <FtDialog title="용돈 한도 등록" handleClose={props.handleClose}>
            <div style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                계정: {accountName}

                <InputWrap label="적용일">
                    <DateInput
                        value={data.applyDate}
                        required={true}
                        onChange={(value) => setData({...data, applyDate: value})}
                    />
                </InputWrap>

                <InputWrap label="금액">
                    <AmountInput
                        fullWidth={true}
                        value={data.amount}
                        onChange={(value) => setData({...data, amount: value})}
                    />
                </InputWrap>

                <StringInput
                    placeholder="상세 내역"
                    value={data.detail}
                    onChange={(v) => setData({...data, detail: v})}
                    fullWidth
                />
            </div>

            <div style={{display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16}}>
                <FtButton variant="outlined" onClick={() => props.handleClose()}>취소</FtButton>
                <FtButton variant="contained" onClick={handleSubmit}>저장</FtButton>
            </div>
        </FtDialog>
    );
}
